export const environment = {
  production: true,
  title: 'Production Environment Heading',
  apiURL: 'https://jkmaquinarias.lubrikuv.com/backend/'
};
